import { useEffect } from "react";
import { useLocation } from "react-router";
import {
  hasConsent,
  initUmami,
  initClarity,
  removeScript,
  trackPageView,
} from "@/lib/analytics";

const IS_DEV = import.meta.env.DEV;
const UMAMI_WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID as string | undefined;
const UMAMI_SCRIPT_URL = import.meta.env.VITE_UMAMI_SCRIPT_URL as string | undefined;
const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined;

function syncConsentScripts() {
  if (IS_DEV) return;

  if (hasConsent()) {
    if (UMAMI_WEBSITE_ID && UMAMI_SCRIPT_URL) {
      initUmami(UMAMI_WEBSITE_ID, UMAMI_SCRIPT_URL);
    }
    if (CLARITY_PROJECT_ID) {
      initClarity(CLARITY_PROJECT_ID);
    }
  } else {
    removeScript("umami-script");
    removeScript("clarity-script");
  }
}

export default function AnalyticsProvider() {
  const { pathname } = useLocation();

  // Init/teardown on mount + consent changes
  useEffect(() => {
    syncConsentScripts();

    const onConsentChanged = () => syncConsentScripts();
    window.addEventListener("consent-changed", onConsentChanged);
    return () => window.removeEventListener("consent-changed", onConsentChanged);
  }, []);

  // Track page views on route change
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
